import React, { useState, useRef } from "react";
import { AdSlot } from "../components/ads/AdSlot";
import { wrapIrSlots } from "../components/ads/irSlots";
import { contentToChunks } from "../utils/adChunks";
import { YandexAd } from "../components/YandexAd/YandexAd";
import { InRead } from "../components/jsonBlocks/InRead/InRead";

function calculateChunksCount(chunksLength) {
    const configArray = [
        { chunkLength: 3, config: { adfoxNum: 1, paragraphNum: 1 } },
        { chunkLength: 6, config: { adfoxNum: 1, paragraphNum: 2 } },
        { chunkLength: 8, config: { adfoxNum: 2, paragraphNum: 3 } },
        { chunkLength: 12, config: { adfoxNum: 3, paragraphNum: 3 } },
        { chunkLength: 16, config: { adfoxNum: 4, paragraphNum: 3 } },
        { chunkLength: 20, config: { adfoxNum: 4, paragraphNum: 4 } },
    ];
    if (chunksLength >= 20) {
        return { adfoxNum: 4, paragraphNum: 5 };
    }
    if (chunksLength < 3) {
        return { adfoxNum: 0, paragraphNum: 0 };
    }
    for (const item of configArray) {
        if (chunksLength <= item.chunkLength) {
            return item.config;
        }
    }
}

function getAdfoxComponents(isFull, isDesktop, options) {
    return {
        1: options ? <YandexAd blockId={options.ir1.blockId} /> : null,
        2: options ? <YandexAd blockId={options.ir2.blockId} /> : null,
        3: options ? <YandexAd blockId={options.ir3.blockId} /> : null,
        4: options ? <YandexAd blockId={options.ir4.blockId} /> : null,
    };
}

function split(news) {
    const chunks = contentToChunks(news);
    const config = calculateChunksCount(chunks.length);
    for (let i = 0; i <= config.adfoxNum; i++) {
        let insertPosition = config.paragraphNum + i * (config.paragraphNum + 1);
        if (insertPosition < chunks.length) {
            chunks.splice(insertPosition, 0, "ADFOX");
        }
    }
    return chunks;
}

const NewsText = ({ news, isFull, isDesktop, showAdfox, options, objectId, showId, jsonData }) => {
    const contentRef = useRef(null);
    const chunks = split(news);
    const adfoxNum = calculateChunksCount(chunks.length)["adfoxNum"];
    const selectedComponentsMap = wrapIrSlots(getAdfoxComponents(isFull, isDesktop, options), { isFull, isDesktop });
    let cnt = 1;

    return (
        <div className="news-text-900">
            <div ref={contentRef}>
                {chunks.map((chunk, i) => {
                    if (chunk === "ADFOX" && cnt <= adfoxNum + 1) {
                        cnt += 1;
                        if (showAdfox) {
                            return (
                                <React.Fragment key={`ad-${cnt - 1}`}>{selectedComponentsMap[cnt - 1]}</React.Fragment>
                            );
                        } else {
                            return (
                                <React.Fragment key={`ad-${cnt - 1}`}>
                                    <AdSlot
                                        slot={`ir${cnt - 1}`}
                                        isFull={isFull}
                                        isDesktop={isDesktop}
                                        fallback={
                                            <InRead
                                                jsonData={jsonData.slice(cnt - 2, cnt - 1)}
                                                objectId={objectId}
                                                showId={showId}
                                            />
                                        }
                                    />
                                </React.Fragment>
                            );
                        }
                    }
                    if (i === chunks.length - 1) {
                        cnt = 0;
                    }
                    return (
                        <React.Fragment key={i}>
                            <p hidden={chunk === "ADFOX"} dangerouslySetInnerHTML={{ __html: chunk }} />
                        </React.Fragment>
                    );
                })}
            </div>
        </div>
    );
};

export default NewsText;
